import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import TabToggle from '../../../shared-components/tab-toggle/TabToggle';
// import HealthFaultAnalytics from '../station-reports/HealthFaultAnalytics';
import PowerConsumptionReportChart from '../station-reports/PowerConsumptionReportChart';
import ReportsSummary from '../station-reports/ReportsSummary';
import RevenueReportChart from '../station-reports/RevenueReportChart';
import UtilizationEfficiencyReport from '../station-reports/UtilizationEfficiencyReport';

/**
 *  Station Reports
 * @returns
 */
function StationReports() {
  const { t } = useTranslation('stationManagement');
  const [selectedTab, setSelectedTab] = useState<string>('');

  return (
    <div>
      <TabToggle
        tabs={[
          t('summary'),
          t('revenueEnergyTrends'),
          t('utilizationEfficiency'),
          // 'Health & Fault Analytics',
        ]}
        defaultTab={t('summary')}
        onChange={(tab) => setSelectedTab(tab)}
      />{' '}
      <div style={{ marginTop: '20px' }}> </div>
      {selectedTab === t('summary') && (
        <div>
          <ReportsSummary />
        </div>
      )}
      {selectedTab === t('revenueEnergyTrends') && (
        <div className="revenue-energy-trends">
          <PowerConsumptionReportChart />
          <RevenueReportChart />
        </div>
      )}
      {selectedTab === t('utilizationEfficiency') && (
        <div>
          <UtilizationEfficiencyReport />
        </div>
      )}
      {selectedTab === t('healthFaultAnalytics') && <div>{/* <HealthFaultAnalytics /> */}</div>}
    </div>
  );
}

export default StationReports;
